window.isFetchFunctionOveridden = false;

const tlCartGoalEmbedOverride1 = function () {
    if (!window || !window.Shopify) return;

    const CartEvents = {
        add: "TLCARTGOAL:add",
        update: "TLCARTGOAL:update",
        change: "TLCARTGOAL:change",
        clear: "TLCARTGOAL:clear",
        mutate: "TLCARTGOAL:mutate",
    };

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe",
    ];

    function isShopifyCartURL(url) {
        if (url instanceof URL) url = url.href;
        if (typeof url == "object" && url.url) url = url.url;
        if (!url) return false;

        try {
            let path = url.split("/").pop();
            path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e);
            return false;
        }
    }

    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch {}
        }
        window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
                break;
            default:
                break;
        }
    }

    function XHROverride() {
        if (!window.XMLHttpRequest) return;
        const originalOpen = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function () {
            const url = arguments[1];
            this.addEventListener("load", function () {
                if (isShopifyCartURL(url)) {
                    dispatchEvent(url, this.response);
                }
            });
            return originalOpen.apply(this, arguments);
        };
    }

    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== "function") return;
        const originalFetch = window.fetch;
        window.fetch = async function () {
            let [resource, config] = [...arguments];
            const response = originalFetch.apply(this, arguments);
            if (isShopifyCartURL(arguments[0]) && config && config.body && config.body !== "{}") {
                const cartDataReq = await originalFetch("/cart.js", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const cartDataRes = await cartDataReq.json();
                // Case: Change or Update cart
                isChangeCartLine = true;
                let items = JSON.parse(JSON.stringify(cartDataRes.items));
                let lineChangeIndex = null;
                let quantity = 1;

                if (!resource.includes("add")) {
                    let bodyArgument = null;
                    if (config.body) {
                        if (typeof config.body === "string") {
                            try {
                                bodyArgument = JSON.parse(config.body);
                            } catch (error) {
                                console.error("Invalid body for JSON parsing during fetch override:", error);
                            }
                        } else if (config.body instanceof FormData) {
                            bodyArgument = {};
                            config.body.forEach((value, key) => {
                                bodyArgument[key] = value;
                            });
                        } else {
                            bodyArgument = config.body;
                        }
                    }
                    if (bodyArgument) {
                        let newLineQty = Number(bodyArgument.quantity);
                        if (bodyArgument.line) {
                            lineChangeIndex = Number(bodyArgument.line) - 1;
                        } else if (bodyArgument.id) {
                            items.map((item, index) => {
                                if (item.key === bodyArgument.id) {
                                    lineChangeIndex = index;
                                } else if (item.id === bodyArgument.id) {
                                    lineChangeIndex = index;
                                }
                            });
                        } else if (bodyArgument.updates) {
                            const updates = bodyArgument.updates;
                            items.map((item, index) => {
                                if ((updates[item.key] === item.quantity) !== Number(updates[item.key])) {
                                    lineChangeIndex = index;
                                    newLineQty = Number(updates[item.key]);
                                }
                            });
                        }
                        quantity = newLineQty;
                        await window.tlCartGoalEmbed.checkGiftsInCart(cartDataRes, lineChangeIndex, quantity);
                    }
                }
                response.then((res) => {
                    res.clone()
                        .json()
                        .then((data) => dispatchEvent(res.url, data));
                });
            }

            return response;
        };
    }

    fetchOverride();
    XHROverride();
};

const setTitlesDisplay = (display) => {
    const rewardDescription = document.querySelector(".tl__cart-goal__reward-description__drawer");

    if (rewardDescription) {
        rewardDescription.style.display = display;
    }
};

const setUnreachedCheckpointIconBorderColor = (color) => {
    const allCheckpoints = document.querySelectorAll(".tl__cart-goal__goal-check-point__drawer");

    if (allCheckpoints.length) {
        allCheckpoints.forEach((e, index) => {
            if (index > window.tlCartGoalEmbed.passedMilestone.lastest) {
                e.style.borderColor = color;
            }
        });
    }
};

const removeItemText = () => {
    const allProductImageInfo = document.querySelectorAll(".tl__cart-goal__product-image-info");

    if (allProductImageInfo.length) {
        allProductImageInfo.forEach((container) => {
            const spans = container.querySelectorAll("span");
            const lastSpan = spans[spans.length - 1];

            if (lastSpan) {
                lastSpan.textContent = lastSpan.textContent.replace(/\s*item\s*/i, "").trim();
            }
        });
    }
};

const newRenderAllCartGoals = () => {
    let customRootElementCartPage = window.tlCartGoalEmbed.cartDisplay;
    let customRootElementCartDraw = window.tlCartGoalEmbed.cartDrawDisplay;
    let tlCartGoalLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE));

    if (document.querySelectorAll(".tl__cart-goal__container__drawer")) {
        document.querySelectorAll(".tl__cart-goal__container__drawer").forEach((ele) => ele.remove());
    }

    if (window.tlCartGoalEmbed.cartTotal === 0) {
        return;
    }

    // inject cart goals into cart drawer and cart page
    if (customRootElementCartPage.selector || customRootElementCartDraw.selector) {
        if (customRootElementCartPage.selector) {
            if (customRootElementCartPage.position === "prepend") {
                document.querySelectorAll(customRootElementCartPage.selector).forEach((ele, index) => {
                    let htmlObject = document.createElement("div");
                    htmlObject.classList.add("tl-custom-cart-goal-container");
                    htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                    ele.prepend(htmlObject);
                });
            } else {
                let position = customRootElementCartPage.position === "before" ? "beforebegin" : "afterend";
                document
                    .querySelectorAll(customRootElementCartPage.selector)
                    .forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
            }
        }
        if (customRootElementCartDraw.selector) {
            let position;
            if (customRootElementCartDraw.position === "prepend") {
                position = "prepend";
                document.querySelectorAll(customRootElementCartDraw.selector).forEach((ele, index) => {
                    let htmlObject = document.createElement("div");
                    htmlObject.classList.add("tl-custom-cart-goal-container");
                    htmlObject.innerHTML = window.tlCartGoalEmbed.renderCartGoal(index);
                    ele.prepend(htmlObject);
                });
            } else {
                position = customRootElementCartDraw.position === "before" ? "beforebegin" : "afterend";
                document
                    .querySelectorAll(customRootElementCartDraw.selector)
                    .forEach((ele, index) => ele.insertAdjacentHTML(position, window.tlCartGoalEmbed.renderCartGoal(index)));
            }
        }
    } else {
        if (window.tlCartGoalEmbed.cartTotal === 0) {
            window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION = "beforebegin";
        }
        document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).forEach((ele, index) => {
            ele.insertAdjacentHTML(window.tlCartGoalEmbed.ROOT_SELECTOR_POSITION, window.tlCartGoalEmbed.renderCartGoal(index));
        });
    }

    if (window.tlCartGoalEmbed.passedMilestone.gift !== -1) {
        tlCartGoalLocalStorage.selectedGifts[window.tlCartGoalEmbed.passedMilestone.gift]?.map((idx) => {
            window.tlCartGoalEmbed.renderSelectedGift(window.tlCartGoalEmbed.passedMilestone.gift);
        });
    }

    setUnreachedCheckpointIconBorderColor("lightgray");
    removeItemText();

    window.tlCartGoalEmbed.addTrackImpressionEvent();
};

const newUpdateAllCartGoals = () => {
    let cartGoalsContainerElements = document.querySelectorAll(".tl__cart-goal__container__drawer");
    if (cartGoalsContainerElements.length) {
        cartGoalsContainerElements.forEach((ele, index) => {
            let rewardsContainer = document.querySelector(`.tl__cart-goal__free-gift-container-${index}`);
            if (rewardsContainer) {
                rewardsContainer.innerHTML = window.tlCartGoalEmbed.updateCartGoal(index);

                setUnreachedCheckpointIconBorderColor("lightgray");
                removeItemText();
            }
        });
    } else {
        window.tlCartGoalEmbed.renderAllCartGoals();
    }
};

const intervalId = setInterval(() => {
    const steps = {
        embed: false,
        progressBar: false,
    };

    if (window.tlFreeGiftBlock && !steps.embed) {
        window.tlFreeGiftBlock.handleClaimGifts = () => {};
        window.tlFreeGiftBlock.handleAutoAdd = () => {};

        steps.embed = true;
    }

    if (window.tlCartGoalEmbed && !steps.progressBar) {
        if (window.location.pathname === "/cart") {
            const cartDrawer = document.querySelector("cart-drawer#cart-drawer");

            if (cartDrawer) {
                cartDrawer.remove();
            }
        } else {
            const target = document.querySelector("#cart-drawer");

            if (target) {
                const observer = new MutationObserver(() => {
                    if (!target.querySelector(".tl__cart-goal__container__drawer")) {
                        observer.disconnect();

                        window.tlCartGoalEmbed.updateAllCartGoals();

                        setTimeout(() => {
                            observer.observe(target, { childList: true, subtree: true });
                        }, 750);
                    }
                });

                observer.observe(target, { childList: true, subtree: true });
            }
        }

        let originalFetch = window.fetch;
        Object.defineProperty(window, "fetch", {
            set(v) {
                if (window.isFetchFunctionOveridden) return;
                originalFetch = v;
            },
            get() {
                return originalFetch;
            },
        });

        setTimeout(() => {
            tlCartGoalEmbedOverride1();

            window.isFetchFunctionOveridden = true;
        }, 1000);

        window.tlCartGoalEmbed.renderAllCartGoals = newRenderAllCartGoals;
        window.tlCartGoalEmbed.updateAllCartGoals = newUpdateAllCartGoals;

        let _cartTotal = window.tlCartGoalEmbed.cartTotal;
        Object.defineProperty(window.tlCartGoalEmbed, "cartTotal", {
            get() {
                return _cartTotal;
            },
            set(value) {
                _cartTotal = value;

                // Hide progress bar if no items in rule are added to the cart
                if (document.querySelectorAll(".tl__cart-goal__container__drawer")) {
                    document.querySelectorAll(".tl__cart-goal__container__drawer").forEach((ele) => ele.remove());
                }
            },
        });

        steps.progressBar = true;
    }

    if (steps.embed && steps.progressBar) {
        clearInterval(intervalId);
    }
}, 50);

setTimeout(() => {
    clearInterval(intervalId);
}, 5000);
